// Auto-generated by scripts/xliff-to-json.cjs -- do not edit by hand

export const translations: Record<string, string> = {
  's17f33773d05f3aed': `Administración de usuarios`,
  'sb46734737dd208bb': `Registros de auditoría`,
  's36e195872312e3b4': `Administración del sitio`,
  's17669567f329206c': `Crear sitio`,
  's49730f3d5751a433': `Cargando...`,
  's3741f519c32ac391': `Nuevo`,
  's417b90913e05bc17': `Vista previa`,
  'sffe2914d4b7c91ee': `Acceso anticipado`,
  's3d64ea063be4c9f2': `Auditoría unificada`,
  's596a144afb429d94': `Más productos`,
  's6d8c02aee480af7a': `Menú`,
  's6abb1cd87fe0114e': `Inicio`,
  's5e8250fb85d64c23': `Cerrar`,
  's691d6163aaabb69b': `Perfil de usuario`,
  's352719d86112de9a': `Ayuda`,
  'admin': `Administración`,
  'h88d78370fa007ca9': `Proveedores de identidad y autenticación`,
  'sitemenu.dashboard': `Dashboard`,
  'sitemenu.dashboard.dynamicdashboard': `Dashboard (Vista previa)`,
  'sitemenu.assets': `Activos`,
  'sitemenu.smartrules': `Reglas inteligentes`,
  'sitemenu.discovery': `Descubrimiento`,
  'sitemenu.discovery.newdiscoveryscan': `Ejecutar un nuevo análisis de descubrimiento`,
  'sitemenu.discovery.activeandcompletedscans': `Análisis activos/completados`,
  'sitemenu.discovery.scheduledscans': `Análisis programados`,
  'sitemenu.discovery.discoveryscanners': `Escáneres de descubrimiento`,
  'sitemenu.managedsystems': `Sistemas administrados`,
  'sitemenu.managedaccounts': `Cuentas administradas`,
  'sitemenu.passwordsafe': `Password Safe`,
  'sitemenu.passwordsafe.accounts': `Cuentas`,
  'sitemenu.passwordsafe.approvals': `Aprobaciones`,
  'sitemenu.passwordsafe.activesessions': `Sesiones activas`,
  'sitemenu.passwordsafe.completedsessions': `Sesiones completadas`,
  'sitemenu.passwordsafe.administratorsessions': `Sesiones de administrador`,
  'sitemenu.analyticsandreportingtrident': `Análisis e informes`,
  'sitemenu.analyticsandreporting.viewallreports': `Ver todos los informes`,
  'sitemenu.teampasswords': `Secrets Safe`,
  'sitemenu.analytics': `Análisis e informes`,
  'sitemenu.configuration': `Configuración`,
  'sitemenu.about': `Acerca de`,
  'insights.menu.dashboard': `Dashboard`,
  'insights.menu.identitiesPrivileges': `Identidades y privilegios`,
  'insights.menu.identities': `Identidades`,
  'insights.menu.accounts': `Cuentas`,
  'insights.menu.entitlements': `Derechos`,
  'insights.menu.secretsSecurity': `Seguridad de secretos`,
  'insights.menu.secrets': `Secretos`,
  'insights.menu.secretsInventory': `Inventario de secretos`,
  'insights.menu.aiSecurity': `Seguridad de IA`,
  'insights.menu.aiAgents': `Agentes de IA`,
  'insights.menu.agentInventory': `Inventario de agentes`,
  'insights.menu.aiThreatDetection': `Detección de amenazas`,
  'insights.menu.aiThreatPolicy': `Política de amenazas`,
  'insights.menu.insights': `Insights`,
  'insights.menu.detections': `Detecciones`,
  'insights.menu.recommendations': `Recomendaciones`,
  'insights.menu.exclusionRules': `Reglas de exclusión`,
  'insights.menu.reporting': `Informes`,
  'insights.menu.integrationsConnections': `Integraciones y conexiones`,
  'insights.menu.integrations': `Integraciones`,
  'insights.menu.connectors': `Conectores`,
  'pmc.explore': `Explorar`,
  'pmc.audit': `Auditoría`,
  'pmc.settings': `Configuración`,
  'home': `Inicio`,
  'policies': `Políticas`,
  'computers': `Equipos`,
  'computer-groups': `Grupos de equipos`,
  'jit-access-management': `Administración de acceso JIT`,
  'analytics': `Análisis`,
  'auditing': `Auditoría`,
  'management-rules': `Reglas de administración`,
  'configuration': `Configuración`,
  'user-management': `Administración de usuarios`,
  'status': `Estado`,
  'downloads': `Consolas y descargas`,
  'my_account': `Mi cuenta`,
  'sd': `Configuración`,
  'jump': `Asset Management`,
  'vault': `Bóveda`,
  'rep_console': `Configuración de consola`,
  'users': `Usuarios y seguridad`,
  'reporting': `Informes`,
  'public_site': `Portales públicos`,
  'dashboard': `Dashboards`,
  'localization': `Localización`,
  'management': `Administración`,
  'appliance': `Dispositivo`,
  'login.status.index': `Información`,
  'login.status_representatives.index': `Representantes`,
  'login.downloads.rep.index': `Rep Console`,
  'login.downloads.drivers.index': `Controladores`,
  'login.my_account.profile.index': `Perfil`,
  'login.my_account.security.index': `Seguridad`,
  'login.sd_general.index': `Opciones`,
  'login.issue.index': `Problemas`,
  'login.team.index': `Equipos de soporte`,
  'login.skill.index': `Habilidades`,
  'login.callback_button.index': `Botones de soporte`,
  'login.custom_fields.index': `Campos personalizados`,
  'login.ms_teams.index': `MS Teams`,
  'login.mcp_config.index': `Servidor MCP`,
  'login.pinned_clients.index': `Jump Clients`,
  'login.shared_jump_groups.index': `Asset Groups`,
  'login.jump_policies.index': `Asset Policies`,
  'login.jump_item_roles.index': `Asset Roles`,
  'login.push_agent.index': `Gateway`,
  'login.jump_item.index': `Assets`,
  'login.endpoint_automation.index': `Automatización de endpoints`,
  'login.vault_account.index': `Cuentas`,
  'login.vault_account_group.index': `Grupos de cuentas`,
  'login.account_policy.index': `Políticas de cuentas`,
  'login.vault_endpoint.index': `Endpoints`,
  'login.vault_domain.index': `Dominios`,
  'login.discovery.index': `Descubrimiento`,
  'login.vault_options.index': `Opciones`,
  'login.vault_password_safe_connection.index': `Conexiones`,
  'login.rep_profile.index': `Configuración de Rep Console`,
  'login.custom_links.index': `Enlaces personalizados`,
  'login.canned_message.index': `Mensajes predefinidos`,
  'login.canned_script.index': `Scripts predefinidos`,
  'login.special_action.index': `Acciones especiales`,
  'login.user.index': `Usuarios`,
  'login.rep_invite.index': `Invitación de representante`,
  'login.security_providers.index': `Proveedores de seguridad`,
  'login.session_policy.index': `Políticas de sesión`,
  'login.group_policy.index': `Políticas de grupo`,
  'login.kerberos_keytab.index': `Kerberos Keytab`,
  'login.licensing.index': `Licencias`,
  'login.session_report.index': `Soporte`,
  'login.license_reporting.index': `Licencias`,
  'login.vault_reporting.index': `Bóveda`,
  'login.compliance.index': `Cumplimiento`,
  'login.jump_item_reporting.index': `Asset`,
  'login.duplicate_pinned_clients_reporting.index': `Jump Clients duplicados`,
  'login.syslog_reporting.index': `Syslog`,
  'login.public_site.index': `Sitios públicos`,
  'login.business_hours.index': `Horario`,
  'login.html_template.index': `Plantillas HTML`,
  'login.customer_notice.index': `Avisos al cliente`,
  'login.file_store.index': `Almacén de archivos`,
  'login.ios_profile.index': `Configuración de iOS`,
  'login.exit_survey.index': `Encuestas de salida`,
  'login.sd_client.index': `Cliente de soporte`,
  'login.dashboard.index': `Dashboards`,
  'login.dashboard.getNetworkRestrictions': `Restricciones de red`,
  'login.nls.real_time_chat.index': `Chat en tiempo real`,
  'login.settings.index': `Software`,
  'login.security_settings.index': `Seguridad`,
  'login.site_settings.index': `Configuración del sitio`,
  'login.email_settings.index': `Configuración de correo electrónico`,
  'login.outbound_event.index': `Eventos salientes`,
  'login.api_account.index': `Configuración de API`,
  'login.support_settings.index': `Soporte`,
  'login.appliance.index': `Dispositivo`,
  'entitle.menu.requests': `Solicitudes`,
  'entitle.menu.identityGraph': `Permisos`,
  'entitle.menu.workflows': `Flujos de aprobación`,
  'entitle.menu.integrations': `Integraciones`,
  'entitle.menu.bundles': `Paquetes`,
  'entitle.menu.policies': `Políticas de derechos innatos`,
  'entitle.menu.tasks': `Tareas`,
  'entitle.menu.profile': `Mi configuración`,
  'entitle.menu.accessReview': `Resumen`,
  'entitle.menu.requestsLog': `Historial de solicitudes`,
  'entitle.menu.auditLogs': `Registros de auditoría`,
  'entitle.menu.settings': `Configuración de organización`,
  'entitle.menu.users': `Usuarios`,
  'epml.menu.explore': `Explorar`,
  'epml.menu.audit': `Auditoría`,
  'epml.menu.settings': `Configuración`,
  'epml.menu.policy': `Política`,
  'epml.menu.endpoints': `Administración de endpoints`,
  'epml.menu.installers': `Instaladores`,
  'epml.menu.unifiedSearch': `Búsqueda unificada`,
  'epml.menu.events': `Eventos`,
  'epml.menu.consoleAudit': `Auditoría de consola`,
  'epml.menu.searchAndReplay': `Búsqueda y reproducción`,
  'epml.menu.consoleAccess': `Acceso a consola`,
  'epml.menu.epmlSettings': `Configuración de EPML`,
  'epml.menu.roles': `Roles`,
  'epml.menu.siemConnections': `Conexiones SIEM`,
  'epml.menu.directoryServices': `Servicios de directorio`,
  'epml.menu.linuxHostAuth': `Autenticación de host Linux`,
  'menu-phantom-labs': `Phantom Labs (es)`,
  'ai-coworkers.menu.dashboards': `Panel`,
  'ai-coworkers.menu.inventory': `Visibilidad`,
  'ai-coworkers.menu.inventory.agents': `Agentes de IA`,
  'ai-coworkers.menu.inventory.mcp-servers': `Servidores MCP`,
  'ai-coworkers.menu.inventory.model-endpoints': `Endpoints de LLM`,
  'ai-coworkers.menu.inventory.agent-skills': `Habilidades de agentes`,
  'ai-coworkers.menu.inventory.endpoints': `Endpoints`,
  'ai-coworkers.menu.intelligence': `Inteligencia`,
  'ai-coworkers.menu.agents.events': `Eventos`,
  'ai-coworkers.menu.intelligence.coding-sessions': `Sesiones de IA`,
  'ai-coworkers.menu.control': `Protección`,
  'ai-coworkers.menu.control.policies': `Políticas`,
  'ai-coworkers.menu.control.exceptions': `Solicitudes de excepción`,
  'ai-coworkers.menu.control.yara-rules': `Reglas YARA`,
  'ai-coworkers.menu.settings': `Configuración`,
  'ai-coworkers.menu.settings.connectors': `Conectores`,
  'ai-coworkers.menu.settings.license': `Licencia y uso`,
  'ai-coworkers.menu.settings.administration': `Administración`,
  'ai-coworkers.menu.agents.deployment': `Implementación`,
  'ai-coworkers.menu.settings.update-strategy': `Estrategia de actualización`,
  'sa91c1893f06e9a91': `Tokens SCIM`,
  'sb5cd73af5ec790f6': `Identidades de carga de trabajo`,
  's29c1fa87a0c0ee4c': `Autenticación de directorio`,
  's177fa3e0b2ef5171': `Lista de permitidos de IP`,
  's4c9351ce0cc28196': `Navegación de productos`,
  's76902262e33e63b5': `Alternar la navegación lateral`,
  's714ea1e6436002a2': `Mantener la navegación anclada`,
  's416434bef0c17abc': `No se pudo cargar el menú. Ciérrelo y vuelva a abrirlo para intentarlo de nuevo.`,
  'admin.menu.users': `Administración de usuarios`,
  'admin.menu.identity-providers': `Proveedores de identidad y autenticación`,
  'admin.menu.directory-auth': `Autenticación de directorio`,
  'admin.menu.workload-identities': `Identidades de carga de trabajo`,
  'admin.menu.scim-tokens': `Tokens SCIM`,
  'admin.menu.user-groups': `Grupos de usuarios`,
  'admin.menu.roles': `Roles`,
  'admin.menu.organization-settings': `Configuración de la organización`,
  'admin.menu.ip-allowlist': `Lista de permitidos de IP`,
  'admin.menu.audit': `Registros de auditoría`,
  'admin.menu.site-admin': `Administración del sitio`,
  'admin.menu.site-admin.create': `Crear sitio`,
  'siteSelectorLabel': `Sitio`,
  'siteSelectorSearchPlaceholder': `Buscar sitios`,
  'siteSelectorNoSitesFound': `No se han encontrado sitios`,
  'siteSelectorDataResidency': `residencia de datos`,
  'breadcrumbNavLabel': `Ruta de navegación`,
  'breadcrumbOverflowLabel': `Mostrar más elementos de navegación`,
};
